export default __webpack_public_path__ + "static/media/benefit_3.c42880be.svg";